import { render, staticRenderFns } from "./LomEventsCreate.vue?vue&type=template&id=60243fca"
import script from "./LomEventsCreate.vue?vue&type=script&lang=js"
export * from "./LomEventsCreate.vue?vue&type=script&lang=js"
import style0 from "./LomEventsCreate.vue?vue&type=style&index=0&id=60243fca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports